import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from 'src/app/config/api.config';
import { LeadDTO } from 'src/app/models/site/leadDTO';
import { CookieManagerService } from '../analytics/cookie-manager.service';
import { Page } from 'src/app/models/page.model';


interface LeadOrigemDTO {
  curso: string;
  unidade: string;
  turno: string;
  formacao: string;
  modalidade: string;
  origem: string;
  nomeOrigem: string;
  urlOrigem: string;
  ultimaPaginaVisitada: string;
  dataCadastro: Date;
  status: string; 
  statusFormatado: string;
}

interface LeadAgrupadoDTO {
  nome: string;
  email: string;
  telefone: string;  
  dadosOrigem: LeadOrigemDTO[];
}



@Injectable({
  providedIn: 'root'
})
export class LeadService {

  constructor(
    private http: HttpClient,
    private cookieManagerService: CookieManagerService
  ) { }

  /**
   * Insere um novo Lead
   */
  insert(lead: LeadDTO): Observable<any> {

    lead.idSessao = this.cookieManagerService.getSessionId();

    return this.http.post<any>(`${API_CONFIG.apiURL}/leads`, lead, {
      observe: 'response'
    });
  }

  


  verificarExistenciaLead(
    email: string,
    telefone: string,
    idCurso: number,
    idUnidade?: number
  ): Observable<LeadDTO | null> {

    let params = new HttpParams()
      .set('email', email)
      .set('telefone', telefone)
      .set('idCurso', idCurso.toString());

    if (idUnidade != null) {
      params = params.set('idUnidade', idUnidade.toString());
    }
    
    return this.http.get<LeadDTO>(`${API_CONFIG.apiURL}/leads/verificar-existencia`, { params });
  }


  buscarPorFiltro(
    texto: string,
    idsCursos: number[],
    idsUnidades: number[],
    incluirLeadsSemUnidadeDefinida: boolean,
    idFormacao: number,
    idModalidade: number,
    idHabilitacao: number,
    dataInicial: string, // formato ISO 8601, ex: '2025-06-13T00:00:00'
    dataFinal: string,
    status: string,      // deve ser exatamente o valor do enum, ex: 'CANDIDATO'
    page: number, 
    pageSize: number, 
    sort: string = 'ASC'
  ): Observable<Page<LeadAgrupadoDTO>> {

    let params = new HttpParams();

    if (idsCursos?.length) {
      idsCursos.forEach(id => {
        params = params.append('idsCursos', id.toString()); // múltiplos idsCursos=...
      });
    }

    if (idsUnidades) {
      idsUnidades.forEach(id => {
        params = params.append('idsUnidades', id.toString()); // múltiplos idUnidades=...
      });
    }

    params = params.append('incluirLeadsSemUnidadeDefinida', incluirLeadsSemUnidadeDefinida);

    if (texto) {
      params = params.set('texto', texto);
    }

    if (dataInicial) {
      params = params.set('dataInicial', dataInicial);
    }

    if (dataFinal) {
      params = params.set('dataFinal', dataFinal);
    }

    if (status) {
      params = params.set('status', status);
    }

    if (idFormacao) {
      params = params.set('idFormacao', idFormacao.toString());
    }

    if (idModalidade) {
      params = params.set('idModalidade', idModalidade.toString());
    }

    if (idHabilitacao) {
      params = params.set('idHabilitacao', idHabilitacao.toString());
    }

    params = params.set('page', page.toString())
      .set('size', pageSize.toString())
      .set('sort', sort);

    return this.http.get<Page<LeadAgrupadoDTO>>(`${API_CONFIG.apiURL}/leads/buscarPorFiltro`, { params });
  }


  getResumoDashboard(filtro: any): Observable<any> {
    let params = new HttpParams();

    if (filtro.texto) {
      params = params.set('texto', filtro.texto);
    }
    if (filtro.idsCursos) {
      filtro.idsCursos.forEach((id: number) => {
        params = params.append('idsCursos', id.toString());
      });
    }
    if (filtro.idUnidade) {
      params = params.set('idUnidade', filtro.idUnidade);
    }
    if (filtro.idFormacao) {
      params = params.set('idFormacao', filtro.idFormacao);
    }
    if (filtro.idModalidade) {
      params = params.set('idModalidade', filtro.idModalidade);
    }
    if (filtro.idHabilitacao) {
      params = params.set('idHabilitacao', filtro.idHabilitacao);
    }
    if (filtro.dataInicial) {
      params = params.set('dataInicial', filtro.dataInicial);
    }
    if (filtro.dataFinal) {
      params = params.set('dataFinal', filtro.dataFinal);
    }
    if (filtro.status) {
      params = params.set('status', filtro.status);
    }

    return this.http.get(`${API_CONFIG.apiURL}/leads/resumo-dashboard`, { params });
  }
  
}
